export default __webpack_public_path__ + "static/media/success-background.79311033.svg";